import React from 'react'
import BaseElfWidget from './BaseElfWidget'
import { qualifyFormReviewsWidgetConfig } from '../../config/elfSight'

const QualifyFormReviewWidget = () : JSX.Element => {
  const {id, name} = qualifyFormReviewsWidgetConfig

  return (
    <div className="pb-7 sm:px-4 md:px-6 sm:min-h-[350px] lg:min-h-[450px]">
      <BaseElfWidget widgetId={id} widgetName={name} />
    </div>
  )
}

export default QualifyFormReviewWidget
